import React from 'react';
import { useTranslation } from 'react-i18next';
import { compose } from '@/utils/story-composer';
import LibraryItemTile from '@/components/library-elements/library-item-tile';
import Button from '@/components/elements/button';
import { StylingEnums } from '@/enums/styling';
import { LibraryPages, getLibraryUrlPrefix } from '@/utils/url';

function LibraryDiscoverMore(props) {
	const { t } = useTranslation();
	const { ButtonEnum } = StylingEnums;

	const { pageContext } = props;
	const { locale, currentContentItem, possibleItems } = pageContext;

	// Get the IDs of the featured items, defined in Storyblok
	const {
		content_item_tool_id_1: toolId1,
		content_item_tool_id_2: toolId2,
		content_item_tool_id_3: toolId3,
		content_item_tool_id_4: toolId4,
		content_item_lesson_id_1: lessonId1,
		content_item_lesson_id_2: lessonId2,
		content_item_lesson_id_3: lessonId3,
		content_item_lesson_id_4: lessonId4,
	} = props;

	const isTool = currentContentItem.type_name === 'tool';
	// Featured items are defined in Storyblok
	const discoverMoreIds = [toolId1, toolId2, toolId3, toolId4, lessonId1, lessonId2, lessonId3, lessonId4];

	// Filter out the current item and only show items with the same type
	const contentItems = possibleItems.filter(
		node =>
			node.model.id !== currentContentItem.id &&
			(isTool ? node.model.type_name === 'tool' : node.model.type_name !== 'tool')
	);

	// Get the featured items
	const discoverMoreItems = contentItems.filter(node => discoverMoreIds.includes(`${node.model.id}`));

	// If there are not enough featured items, fill the array with the latest released items
	if (discoverMoreItems.length < 4) {
		const diff = 4 - discoverMoreItems.length;
		for (let i = 0; i < diff; i++) {
			discoverMoreItems.push(contentItems.filter(node => !discoverMoreIds.includes(`${node.model.id}`))[i]);
		}
	}

	return (
		<div className="container pb-20">
			<div className="prose">
				<h2 className="font-sans text-2xl leading-8 font-semibold text-center">{t('gynzy-library.discover-more')}!</h2>
			</div>
			<div className="flex justify-center flex-wrap">
				{discoverMoreItems.map(item => (
					<LibraryItemTile key={item.id} locale={locale} item={item} />
				))}
			</div>
			<div className="flex justify-center pt-5">
				<Button
					buttonType={ButtonEnum.PRIMARY}
					text={t('gynzy-library.discover-more')}
					link={{
						linktype: 'url',
						url: `/${getLibraryUrlPrefix(locale, t, isTool ? LibraryPages.ALL_TOOLS : LibraryPages.ALL_LESSONS)}`,
					}}
				/>
			</div>
		</div>
	);
}

export default LibraryDiscoverMore;

compose('public-library-discover-more', LibraryDiscoverMore);
